import classnames from 'classnames';
import React from 'react';

import styles from 'iss/styles/Flex.styl';

/** Creates a side by side column container using CSS flexbox.
 *
 * Props:
 * className, id: passed to the container element as is
 * children: Child elements to render. Use FlexItem components or the flexAllChildren prop.
 * flexAllChildren: Automatically wrap all child elements in a FlexItem if they are not already wrapped
 * all other props are added to the style prop of the container element for easy styling
 *
 */
export function Flex({children, className, id, flexAllChildren, ...style}) {
  return <div style={style} className={classnames(className, styles.flex)} id={id}>
    {flexAllChildren ? autoItemize(children) : children}
  </div>;
}

/** A more styled version of Flex with custom margins and white-space: nowrap applied to it */
export function FlexRow({className, ...props}) {
  return Flex({...props, className: classnames(className, styles.flexRow)});
}

function autoItemize(children) {
  return React.Children.map(children, child => {
    //(<FlexItem />).type === FlexItem expect when
    //using react hot loader which messes it up :(
    const isFlexItem = child && child.type && child.type === (<FlexItem />).type;
    const flex = child && child.props && child.props.flex;
    return isFlexItem ? child : <FlexItem flex={flex}>{child}</FlexItem>;
  });
}

/** An item in a Flex or FlexRow
 *
 * Props:
 * className, id: passed to the container element as is
 * children: Normal children
 * all other props are added to the style prop of the container element for easy styling
 *
 */
export function FlexItem({children, className, id, ...style}) {
  return <div style={style} className={classnames(className, styles.flexItem)} id={id}>{children}</div>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/Flex.jsx